// index.js

import ReactDOM from 'react-dom/client';
import App from './App';
import { Provider } from 'react-redux';
import { store } from './store/configureStore';
import { ThemeProvider } from './theme/ThemeProvider';
import 'antd/dist/reset.css';
import './index.sass';
import './accessibility.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </Provider>
);
